export interface Banner {
  bannerId: string;
  title: string;
  description: string;
  imageUrl: string;
  mobileImageUrl: string;
  tabletImageUrl: string;
  location: string;
  order: number;
  linkUrl: string;
  active: boolean;
  fromDate: string;
  toDate: string;
  date: string;
  createdAt: string;
  updatedAt: string;
}
